import React from 'react'
import PropTypes from 'prop-types'
import PerformanceRatingAndCompaRatioSummaryReport from './PerformanceRatingAndCompaRatioSummaryReport'
import DataFilters from '../../DataFilters'
import { round } from '../../../../../helpers'
import { range, find, get, forEach as objectEach } from 'lodash'

export default function PerformanceRatingAndCompaRatioSummary(props) {

    const groups = ['E', 'M', 'P', 'S']

    const groupsNames = {
        'E': 'Executive',
        'M': 'Management',
        'P': 'Professional',
        'S': 'Support',
    }

    const onApply = (filters) => {
        props.onApply(filters, 'PerformanceRatingAndCompaRatioSummary')
    }

    const levelsData = []
    const groupSummary = {}
    const groupCalculation = []
    const groupTotal = {
        current: {
            total_average_rating_row: 0, total_salary_p50_row: 0, total_salary_p75_row: 0, total_comp_ttc_p50_row: 0, total_comp_ttc_p75_row: 0,
            total_average_rating:0,
            totalN: 0,
            total_salary_p50: 0,
            total_salary_p75: 0,
            total_comp_ttc_p50: 0,
            total_comp_ttc_p75: 0,
        }
    }

    range(14).forEach(level => {
        const levelData = props.masterData.jobGrades.filter(hd => hd.hierarchy === level)
        const groupData = {}
        groups.forEach(g => {
            groupData[g] = {
                level: '',
                title: '',
                current: { n: '', percent: '', salary: '' },
            }
        })

        groupSummary[level] = {
            current: { nSummary: 0, averageRatingSummary: 0, salary_p50_summary: 0, salary_p75_summary: 0, comp_ttc_p50_summary: 0, comp_ttc_p75_summary: 0 },
        }
        groupCalculation[level] = {
            current: {
                number_salary_p50_summary: 0,
                number_salary_p75_summary: 0,
                number_comp_ttc_p50_summary: 0,
                number_comp_ttc_p75_summary: 0,
            }
        }

        let averageRatingCount = 0;

        levelData.forEach(ld => {
            const groupKey = ld.job_grade.slice(0, 1)
            const dataInReport = find(props.reportData, { 'compkit_job_grade': ld.job_grade })

            groupData[groupKey].level = ld.job_grade
            groupData[groupKey].title = ld.job_title

            if (dataInReport) {
                groupSummary[level].current.nSummary += get(dataInReport, 'total', 0)

                // let averageRating = get(dataInReport, 'avg_performance_rating', 0)

                    averageRatingCount++;
                    groupSummary[level].current.averageRatingSummary += round(get(dataInReport, 'avg_performance_rating', 0))

                groupSummary[level].current.salary_p50_summary = round(groupSummary[level].current.salary_p50_summary + round(get(dataInReport, 'avg_comp_salary_p50', 0)))
                groupSummary[level].current.salary_p75_summary = round(groupSummary[level].current.salary_p75_summary + round(get(dataInReport, 'avg_comp_salary_p75', 0)))
                groupSummary[level].current.comp_ttc_p50_summary = round(groupSummary[level].current.comp_ttc_p50_summary + round(get(dataInReport, 'avg_comp_ttc_p50', 0)))
                groupSummary[level].current.comp_ttc_p75_summary = round(groupSummary[level].current.comp_ttc_p75_summary + round(get(dataInReport, 'avg_comp_ttc_p75', 0)))

                groupCalculation[level].current.number_salary_p50_summary += 1 
                groupCalculation[level].current.number_salary_p75_summary += 1
                groupCalculation[level].current.number_comp_ttc_p50_summary += 1
                groupCalculation[level].current.number_comp_ttc_p75_summary += 1
            }
            
            groupSummary[level].current.salary_p50_summary = round((groupSummary[level].current.salary_p50_summary/groupCalculation[level].current.number_salary_p50_summary))
            groupSummary[level].current.salary_p75_summary = round((groupSummary[level].current.salary_p75_summary/groupCalculation[level].current.number_salary_p75_summary))
            groupSummary[level].current.comp_ttc_p50_summary = round((groupSummary[level].current.comp_ttc_p50_summary/groupCalculation[level].current.number_comp_ttc_p50_summary))
            groupSummary[level].current.comp_ttc_p75_summary = round((groupSummary[level].current.comp_ttc_p75_summary/groupCalculation[level].current.number_comp_ttc_p75_summary))
        })

        groupSummary[level].current.averageRatingSummary = round(groupSummary[level].current.averageRatingSummary / averageRatingCount)

        groupTotal.current.total_average_rating += groupSummary[level].current.averageRatingSummary
        if(groupSummary[level].current.averageRatingSummary !== 0) {
            groupTotal.current.total_average_rating_row += 1
        }
        if(groupSummary[level].current.salary_p50_summary !== 0) {
            groupTotal.current.total_salary_p50_row += 1
        }
        if(groupSummary[level].current.salary_p75_summary !== 0) {
            groupTotal.current.total_salary_p75_row += 1
        }
        if(groupSummary[level].current.comp_ttc_p50_summary !== 0) {
            groupTotal.current.total_comp_ttc_p50_row += 1
        }
        if(groupSummary[level].current.comp_ttc_p75_summary !== 0) {
            groupTotal.current.total_comp_ttc_p75_row += 1
        }
        groupTotal.current.totalN += groupSummary[level].current.nSummary
        groupTotal.current.total_salary_p50 = round(groupTotal.current.total_salary_p50 + groupSummary[level].current.salary_p50_summary)
        groupTotal.current.total_salary_p75 = round(groupTotal.current.total_salary_p75 + groupSummary[level].current.salary_p75_summary)
        groupTotal.current.total_comp_ttc_p50 = round(groupTotal.current.total_comp_ttc_p50 + groupSummary[level].current.comp_ttc_p50_summary)
        groupTotal.current.total_comp_ttc_p75 = round(groupTotal.current.total_comp_ttc_p75 + groupSummary[level].current.comp_ttc_p75_summary)

        levelsData.push(groupData)
    })

    groupTotal.current.total_average_rating = round(groupTotal.current.total_average_rating / groupTotal.current.total_average_rating_row).toFixed(1)
    groupTotal.current.total_salary_p50 = round(groupTotal.current.total_salary_p50 / groupTotal.current.total_salary_p50_row).toFixed(1)
    groupTotal.current.total_salary_p75 = round(groupTotal.current.total_salary_p75 / groupTotal.current.total_salary_p75_row).toFixed(1)
    groupTotal.current.total_comp_ttc_p50 = round(groupTotal.current.total_comp_ttc_p50 / groupTotal.current.total_comp_ttc_p50_row).toFixed(1)
    groupTotal.current.total_comp_ttc_p75 = round(groupTotal.current.total_comp_ttc_p75 / groupTotal.current.total_comp_ttc_p75_row).toFixed(1)

    /**
     * Below is the Display logic for each Row
     */
    range(14).forEach(level => {
        groupSummary[level].current.averageRatingSummary = groupSummary[level].current.averageRatingSummary.toFixed(1)
        groupSummary[level].current.salary_p50_summary = groupSummary[level].current.salary_p50_summary.toFixed(1)
        groupSummary[level].current.salary_p75_summary = groupSummary[level].current.salary_p75_summary.toFixed(1)
        groupSummary[level].current.comp_ttc_p50_summary = groupSummary[level].current.comp_ttc_p50_summary.toFixed(1)
        groupSummary[level].current.comp_ttc_p75_summary = groupSummary[level].current.comp_ttc_p75_summary.toFixed(1)
    })

    return (
        <React.Fragment>
            <DataFilters
                fetchedFilterData={props.fetchedFilterData}
                filtersData={props.filtersData}
                onDataFilterSelect={props.onDataFilterSelect}
                componentName={'PerformanceRatingAndCompaRatioSummary'}
                reportFilters={props.reportFilters}
                onApply={onApply}
                resetFilter={props.resetFilter}
                reportFiltersType={props.reportFiltersType}
                reportDataChanged={props.reportDataChanged}
            />
            <PerformanceRatingAndCompaRatioSummaryReport availableColumns={props.availableColumns} groupTotal={groupTotal} groupSummary={groupSummary} groups={groups} groupsNames={groupsNames} levelsData={levelsData}></PerformanceRatingAndCompaRatioSummaryReport>
        </React.Fragment>
    )
}

PerformanceRatingAndCompaRatioSummary.propTypes = {
    masterData: PropTypes.object.isRequired,
    onDataFilterSelect: PropTypes.func.isRequired,
    reportFilters: PropTypes.object.isRequired,
    reportData: PropTypes.array.isRequired,
    onApply: PropTypes.func.isRequired,
}
